"use strict";

function resizeModal() {
  let innerHeight = window.innerHeight;
  const modals = [
    'elastic-modal',
    'organize-party-modal',
    'mobile-gallery-modal',
    'map-modal',
    'contact-screen-modal',
  ];

  for (let modal of modals) {
    const elem = document.querySelector<HTMLElement>(`#${modal} .modal-content`);
    if (!elem || !elem instanceof HTMLElement) {
      continue;
    }
    if (isMobile()) {
      elem.style.height = `${innerHeight}px`;
      elem.style['min-height'] = 0;
    } else {
      elem.style.height = null;
      elem.style['min-height'] = null;
    }
  }
}

(function () {
  window.addEventListener('resize', resizeModal);
})();
